
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M8.106.333c.841.026 1.53.7 1.56 1.554V3H13a.667.667 0 110 1.333h-.667v7.334a2 2 0 01-2 2H3.667a2 2 0 01-2-2V4.333H1A.667.667 0 111 3h3.333V1.887A1.613 1.613 0 016 .333h2.106zm2.894 4H3v7.334c0 .368.298.666.667.666h6.666a.667.667 0 00.667-.666V4.333zm-6 2A.667.667 0 015.667 7v2.667a.667.667 0 01-.667.666.667.667 0 01-.667-.666V7A.667.667 0 015 6.333zm4 0A.667.667 0 019.667 7v2.667a.667.667 0 01-.667.666.667.667 0 01-.667-.666V7A.667.667 0 019 6.333zM8 1.667H6c-.193 0-.333.113-.333.22V3h2.666V1.887c0-.107-.14-.22-.333-.22z"}})])
          )
        }
      }
    